<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import DatePicker from "vue2-datepicker";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import BursListModal from "@/components/modals/burs-list-modal.vue";

export default {
  name: "BursModal",
  components: {
    DatePicker,
    LoadingTemplate,
    BursListModal
  },
  props: {
    modalTitle: String,
  },
  data() {
    return {
      bursModal: {
        show: false,
        title: this.modalTitle || "BURS Information",
      },
      burs: {
        id: 0,
        bursDate: new Date(),
        rfpId: null,
        particulars: null,
        parentBursId: 0,
        isDueAndDemandable: true,
      },
      submitted: false,
      rfpData: {},
      rfpLoading: false,
      selectedParent: null
    };
  },
  validations: {
    burs: {
      particulars: { required },
      bursDate: { required },
    },
  },
  methods: {
    updateData(data) {
      this.burs = cloneDeep(data);
      this.burs.bursDate = data.bursDate ? new Date(data.bursDate) : new Date();
    },
    setRfpData(data){
      this.rfpData = cloneDeep(data);
    },
    async getRFPData(id, type) {
      this.rfpLoading = true;
      if(type.toLowerCase() === 'payment'){
        await this.$store.dispatch("rfppayment/getSinglePayment", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.type = 'payment';
          res.data.totalAmount = res.data.amount;
          this.rfpData = res.data;
        })
        .catch((err) => {
          this.showToast('Something went wrong!', "error");
        });
      } else {
        await this.$store.dispatch("rfppo/GetSingleRfpPo", id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.type = 'po';
          res.data.totalAmount = res.data.amount;
          this.rfpData = res.data;
        })
        .catch((err) => {
          this.showToast('Something went wrong!', "error");
        });
      }
      
      this.rfpLoading = false;
    },
    saveBURS() {
      this.submitted = true;
      this.$v.burs.$touch();
      if (this.$v.burs.$invalid) return;
      let data = JSON.parse(JSON.stringify(this.burs));
      data.bursDate = this.getDate(this.burs.bursDate);
      data.parentBursId = data.parentBursId || 0;
      this.$emit("submit", data);
    },
    selectParent(data){
      this.$refs.bursListModal.getData(data);
    },
    setParentData(data){
      this.burs.parentBursId = data.id;
      this.burs.isDueAndDemandable = true;
      this.selectedParent = data;
    },
  },
};
</script>

<template>
  <b-modal
    id="burs-modal"
    :title="modalTitle"
    size="xl"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
  >
    
    <form @submit.prevent="saveBURS">
      <div class="row">
        <div class="col-md-5 border-end">
          <div class=" card calc-height d-flex justify-content-center shadow-none" >
            <div class="card-header px-2">
              <h5 class="my-0 text-info">
                <i class="bx bx-info-circle me-1"></i>RFP Information
              </h5>
            </div>
            <template v-if="rfpLoading">
              <div class="card-body py-5 my-5 d-flex justify-content-center align-items-center">
                <LoadingTemplate />
              </div>
            </template>
            <template v-if="!rfpLoading && rfpData.id">
              <div class="card-body pt-0 mt-3 px-2" >
                <div class="card-text">
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative">
                      <span class="fw-medium label-float text-info">RFP Number: </span>
                      <span class="text-white d-inline px-4 font-weight-bold font-size-15">{{ rfpData.rfpNumber }}</span>
                    </div>
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative">
                      <span class="fw-medium label-float text-info">Supplier/Payee: </span>
                      <div class="d-flex px-4">
                        <span class="text-white d-inline font-weight-bold font-size-15">{{ rfpData.payee }}</span>
                      </div>
                    </div>
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative">
                      <span class="fw-medium label-float text-info">Amount: </span>
                      <span class="text-white d-inline px-4 font-weight-bold font-size-15">{{ formatCurrency(rfpData.totalAmount) }}</span>
                    </div>
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative">
                      <span class="fw-medium label-float text-info">Date Posted: </span>
                      <span class="text-white d-inline px-4 font-weight-bold font-size-15">{{ formatDate(new Date(rfpData.datePosted)) }}</span>
                    </div>
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative">
                      <span class="fw-medium label-float text-info">Particulars: </span>
                      <div class="d-flex px-4">
                        <span class="text-white d-inline font-weight-bold font-size-15">{{ rfpData.particulars }}</span>
                      </div>
                    </div>
                    <div class="border mb-3 rounded pt-2 pb-1 position-relative" v-if="rfpData.type.toLowerCase() === 'payment'">
                      <span class="fw-medium label-float text-info">Delivery Unit: </span>
                      <span class="text-white d-inline px-4 font-weight-bold font-size-15">{{ rfpData.deliveryUnit }}</span>
                    </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7">
            <div class="mb-3 border d-flex justify-content-center py-3 px-3 rounded border-info align-items-center cursor-pointer" v-if="burs.id == 0" @click="selectParent(rfpData)">
              <template v-if="selectedParent">
                <div>
                  <small class="text-info">{{ selectedParent.serialNumber }}</small>
                  <h5 class="mb-1">
                    {{selectedParent.particulars }} (<span class="text-muted">{{ formatDate(new Date(selectedParent.bursDate)) }}</span>)
                  </h5>
                  <h6 class="text-success mb-0">Amount: {{ formatCurrency(selectedParent.total) }}</h6>
                </div>
              </template>
              <template v-else>
                <i class="bx bx-plus"></i> Select Parent BURS/ORS
              </template>
            </div>
            <div class="mb-3">
              <label for="particulars">BURS/OBRS Date</label>
              <date-picker
                  id="bursDate"
                  v-model="burs.bursDate"
                  :first-day-of-week="1"
                  lang="en"
                  placeholder="Enter BURS/OBRS Date..."
                  :class="{ 'is-invalid': submitted && $v.burs.bursDate.$error }"
                >
                </date-picker>
                <div
                  v-if="submitted && $v.burs.bursDate.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.burs.bursDate.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
              <label for="particulars">Particulars</label>
              <b-form-textarea
                id="particulars"
                v-model="burs.particulars"
                placeholder="Enter Particulars..."
                rows="5"
                :class="{
                  'is-invalid': submitted && $v.burs.particulars.$error,
                }"
              ></b-form-textarea>
              <div
                v-if="submitted && $v.burs.particulars.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.burs.particulars.required">This value is required.</span>
              </div>
            </div>
            <div class="form-check form-checkbox-outline form-check-success mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                id="isDueAndDemandable"
                v-model="burs.isDueAndDemandable"
              />
              <label class="form-check-label" for="isDueAndDemandable">
                Due and Demandable
              </label>
            </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">
          <i class="bx bx-save me-1"></i> {{burs.id > 0 ? 'Update' : 'Obligate'}}
        </button>
        <button type="button" class="btn btn-link" @click="$bvModal.hide('burs-modal')">
          Close
        </button>
      </div>
    </form>
    <BursListModal 
      ref="bursListModal"
      @drop="setParentData" 
    />
  </b-modal>
</template>
<style lang="scss">
.calc-height{
  height: calc(100% - 20px) !important;
}
.label-float{
  position: absolute;
  top: -11px;
  left: 5px;
  background: var(--bs-secondary-bg);
}
</style>